/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_CostInputs */

const en_gc_resources_compare_cost = /** @type {(inputs: Gc_Resources_Compare_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost`)
};

const zh_gc_resources_compare_cost = /** @type {(inputs: Gc_Resources_Compare_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`费用`)
};

/**
* | output |
* | --- |
* | "Cost" |
*
* @param {Gc_Resources_Compare_CostInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_cost = /** @type {((inputs?: Gc_Resources_Compare_CostInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_CostInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_cost(inputs)
	return zh_gc_resources_compare_cost(inputs)
});
export { gc_resources_compare_cost as "gc.resources.compare.cost" }